import * as Sentry from "@sentry/react";
import posthog from "posthog-js";

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || "https://us.i.posthog.com";

export function initAnalytics() {
  if (SENTRY_DSN) {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: import.meta.env.MODE,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      tracesSampleRate: 0.1,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  }

  if (POSTHOG_KEY) {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      person_profiles: "identified_only",
      capture_pageview: false,
    });
  }
}

export function identifyUser(userId: string, traits?: Record<string, unknown>) {
  Sentry.setUser({ id: userId, ...traits });
  if (POSTHOG_KEY) {
    posthog.identify(userId, traits);
  }
}

export function resetUser() {
  Sentry.setUser(null);
  if (POSTHOG_KEY) {
    posthog.reset();
  }
}

export function trackEvent(name: string, properties?: Record<string, unknown>) {
  if (POSTHOG_KEY) {
    posthog.capture(name, properties);
  }
}

export function trackPageView(path: string) {
  if (POSTHOG_KEY) {
    posthog.capture("$pageview", { $current_url: path });
  }
}

export { Sentry };
